export default "__VITE_ASSET__5805d00d__"